import React from 'react';
import { Select, Typography } from 'antd';
import styles from './index.module.scss';

const tradeType = {
  income: '收入',
  expense: '支出',
  transfer: '轉帳',
};

const tradeTypeOptions = Object.entries(tradeType).map(([value, label]) => ({
  value,
  label,
}));

type TradeTypeFilterProps = {
  setFilter: React.Dispatch<React.SetStateAction<Record<string, string>>>;
};

const TradeTypeFilter: React.FC<TradeTypeFilterProps> = ({ setFilter }) => {
  const handleChange = (selectedTradeType: string | undefined) => {
    setFilter((prevFilter) => {
      if (selectedTradeType) {
        return { ...prevFilter, tradeType: selectedTradeType };
      } else {
        const newFilter = { ...prevFilter };
        delete newFilter.tradeType;
        return newFilter;
      }
    });
  };
  return (
    <div>
      <Typography.Text>交易類別：</Typography.Text>
      <Select
        className={styles['select']}
        options={tradeTypeOptions}
        onChange={handleChange}
        allowClear
      />
    </div>
  );
};

export default TradeTypeFilter;
